import agencyApi from 'api/agencyApi';
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

// ---- thunks ----
// lay danh sach giao dich rut tien dai ly
export const thunkGetAgencyTransactionList = createAsyncThunk(
    'agencyTransaction/thunkGetAgencyTransactionList',
    async ({ params }, thunkAPI) => {
        const res = await agencyApi.getAgencyWithdrawTransaction(params);
        return res;
    }
);

// ---- params ----
const initialState = {
    isGettingData: false,
    agencyTransactionList: [],
    total: 0,
};

const agencyTransactionSlice = createSlice({
    name: 'agencyTransaction',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(thunkGetAgencyTransactionList.pending, (state, action) => {
                state.isGettingData = true;
            })
            .addCase(thunkGetAgencyTransactionList.rejected, (state, action) => {
                state.isGettingData = false;
            })
            .addCase(thunkGetAgencyTransactionList.fulfilled, (state, action) => {
                state.isGettingData = false;
                const { result, requests, total } = action.payload;
                if (result === 'success') {
                    state.agencyTransactionList = requests ?? [];
                    state.total = total ?? 0;
                }
            });
    },
});

const { reducer, actions } = agencyTransactionSlice;
export const { } = actions;
export default reducer;
